import React, { useState, useContext } from 'react'
import Context from 'setup/context'
import styled from 'styled-components'
import LocationsModal from '../../_common/modals/LocationsModal'
import QuantityInput from 'pageComponents/_common/form/quantityInput'
import AirlineChip from 'pageComponents/_common/styledComponents/AirlineChip'
import { Detail1 as SkeletonDetail } from 'pageComponents/SearchResults/uiComponents/skeletonItem'
import ItemImage from '../../_common/ItemImage'
import { gtag } from 'ga-gtag';
import { Center, NoHoverLink, ButtonBlue } from 'pageComponents/SearchResults/uiComponents/itemResult'
import { Link } from 'react-router-dom'

const DivItemResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 320px;
  margin: 0 8px 20px 8px;
  padding: 8px 0;
  border-bottom: 1px grey solid;
`

const DivPartNumberRow = styled.div`
  width: 100%;
  display: flex;
  color: #000;
  padding: 0 5px;
  font-size: 12px;
  font-family: Arial, sans-serif;
`

const DivExtendedDetails = styled.div`
  width: 100%;
  display: flex;
  color: #000;
  padding: 0 5px;
  font-size: 12px;
  font-family: Arial, sans-serif;
`
const DivPartNumberRowSpread = styled(DivPartNumberRow)`
  justify-content: center;
`

const P = styled.p`
  margin: 0;
  font-weight: 500;
  margin: 0 4px;
`

const DivPartDetailsRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 99;
  background-color: #fff;
  width: 100%;
`

const DivPartImg = styled.div`
  display: flex;
  width: 150px;
  height: 150px;
  background-color: white;
`

const SmallImg = styled.div`
  display: flex;
  width: 75px;
  height: 75px;
  background-color: white;
`

const DivPartDetails = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px;
`

const PartTitle = styled.h3`
  margin: 0;
  font-weight: 700;
  font-size: 15px;
  color: #000000 !important;
  text-align: center;
  overflow: hidden;
  &:hover{
    cursor: pointer;
    color: #328EFC;
  }
`

const PpartAvailability = styled.p`
  margin: 0;
  font-size: 13px;
`

const ButtonRed = styled.button`
  background-color: #b51029;
  color: white;
  font-weight: 600;
  border: 0;
  padding: 4px 8px;
  box-shadow: 1px 1px 2px #000;
  margin: 0px auto;
  &:hover{
    background-color: rgb(219, 22, 51);
  }
  &:active{
    background-color: #b51029;
    box-shadow: 0px 0px 1px #000;
  }
  &:disabled{
    background-color: grey;
    color: white;
  }
`

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const DivSpace = styled(Div)`
  width: 100%;
  justify-content: center;
  align-items: flex-end;
  flex-grow: 99;
  margin-top: 5px;
`

const Pprice = styled.p`
  color: #328EFC;
  font-size: 18px;
  font-weight: 700;
  padding: 0 4px;
  margin: 0;
`

const ACall = styled.a`
  color: #328EFC;
  font-weight: 700;
  padding: 0 4px;
`

const ImgContainer = styled.div`
  margin: auto;
  object-fit: contain;
  width: 100%;
  height: 100%;
`

const NoHoverAnchor = styled.a`
  &:hover {
    text-decoration: none;
  }
`
const StrikeThrough = styled.span`
    text-decoration: line-through;
`

export default function AccessoryItem({ itemDetails, price, availability, handleAddedToCart, isParentCalculateStock, size, type }) {
    const [quantity, setQuantity] = useState(1)

    const context = useContext(Context)

    const {
        unitPrice,
        unitOfMeasure,
        unitSize,
        roundType
    } = price || {}

    const setQuantityHandler = (qty) => {
        setQuantity(qty)
    }
    function handleAddToCart() {
        if (quantity > 0) {
            context.addItem({
                invMastUid: itemDetails?.invMastUid,
                quantity: quantity,
                itemUnitPriceOverride: null,
                customerPartNumberId: null
            })
            handleAddedToCart(true)
        }
        if (type === 3) {
            gtag("event", "substitute_item_add_to_cart", {
                items: [
                    {
                        item_id: itemDetails.itemCode,
                        item_name: itemDetails.itemDesc,
                    }
                ]
            });
        }
        if (type === 'frequentlyPurchasedItem') {
            gtag("event", "frequently_purchase_together_add_to_cart", {
                items: [
                    {
                        item_id: itemDetails.itemCode,
                        item_name: itemDetails.itemDesc,
                    }
                ]
            });
        }
    }

    if (!itemDetails) return <></>

    const isLarge = size !== 'small'

    const itemLink = `/product/${itemDetails?.itemCodeUrlSanitized}/${itemDetails?.invMastUid}`

    return (
        <DivItemResultContainer style={{ width: isLarge ? null : 250 }}>
            <DivPartDetailsRow>
                {isLarge ? (
                    <DivPartImg>
                        <Link to={itemLink}>
                            <ImgContainer>
                                <ItemImage size='thumbnail' details={itemDetails} lazy={true} />
                            </ImgContainer>
                        </Link>
                    </DivPartImg>
                ) : (
                    <SmallImg>
                        <Link to={itemLink}>
                            <ImgContainer>
                                <ItemImage size='thumbnail' details={itemDetails} lazy={true} />
                            </ImgContainer>
                        </Link>
                    </SmallImg>
                )}

                <DivPartDetails>
                    <PartTitle style={{ height: isLarge ? 45 : null }}><a href={itemLink}>{itemDetails.itemDesc.substring(0, 90)}...</a></PartTitle>
                </DivPartDetails>

                {isLarge && (
                    <DivExtendedDetails>
                        {itemDetails?.extendedDesc && itemDetails.extendedDesc.replaceAll("\"", "")}
                    </DivExtendedDetails>
                )}

                {itemDetails?.isDiscontinued ? (
                    <><DivPartNumberRow>
                        <PpartAvailability>
                            Airline #: <StrikeThrough>AHC{itemDetails?.invMastUid}</StrikeThrough> Discontinued
                        </PpartAvailability>
                    </DivPartNumberRow>
                    </>
                ) : (
                    <>{isLarge && (
                        <DivPartNumberRow>
                            <PpartAvailability>Airline #: AHC{itemDetails?.invMastUid}</PpartAvailability>
                        </DivPartNumberRow>
                    )}</>
                )}


                <LocationsModal
                    invMastUid={itemDetails?.invMastUid}
                    availabilityInfo={availability}
                    unitPrice={price?.unitPrice}
                    isParentCalculateStock={isParentCalculateStock}
                    isAssembly={itemDetails?.isAssembly}
                />
                {itemDetails.itemFamilies?.length > 0 && itemDetails.itemFamilies?.some((i => i.familyInvMastUid === itemDetails.invMastUid)) ?
                    (
                        <Center style={{ margin: 'auto' }}>
                            <NoHoverAnchor href={`/product/${itemDetails.itemCodeUrlSanitized}/${itemDetails.invMastUid}`}>
                                <ButtonBlue>Customize Length</ButtonBlue>
                            </NoHoverAnchor>
                        </Center>
                    )
                    :
                    (
                        <>
                            <DivPartNumberRowSpread>
                                <Div>
                                    {isLarge ? 'Quantity:' : 'Qty:'}
                                    <QuantityInput
                                        quantity={quantity}
                                        unitSize={unitSize}
                                        unitOfMeasure={unitOfMeasure}
                                        roundType={roundType}
                                        handleUpdate={setQuantityHandler}
                                        min='0'
                                        debounce
                                    />
                                    {
                                        (unitSize > 1) && (
                                            <AirlineChip style={{ marginLeft: '0.5rem' }}>
                                                X {unitSize}
                                            </AirlineChip>
                                        )
                                    }
                                </Div>

                            </DivPartNumberRowSpread>
                            <DivSpace>
                                {unitPrice ? (
                                    <Div>
                                        <Pprice>${unitPrice.toFixed(2)}</Pprice>
                                        <P>/{unitOfMeasure}</P>
                                    </Div>
                                ) : !price ? (
                                    <Div>
                                        <SkeletonDetail style={{ margin: 'auto 0 auto 75px', width: 50 }} />
                                    </Div>
                                ) : (
                                    <ACall href="tel:+18009997378">Call for Price</ACall>
                                )}
                            </DivSpace>

                            <DivSpace>
                                {!!price && <ButtonRed disabled={itemDetails.isDiscontinued} onClick={handleAddToCart}>Add to Cart</ButtonRed>}
                            </DivSpace>
                        </>
                    )}
            </DivPartDetailsRow>
        </DivItemResultContainer>
    )
}
